const styles = {
    actionSection: { paddingBottom: "20px", paddingTop: "20PX" },
};

export default styles;
